import FrameConfig from "@lib/classes/FrameConfig";
import { getContent } from "@lib/use_content";
import {
  SendPasswordResetDocument,
  SendPasswordResetMutationVariables,
} from "@graphql/api";

interface SendPasswordResetReturn {
  success: boolean;
  errorMessage?: string;
}

export default async function sendPasswordReset(
  username: string,
): Promise<SendPasswordResetReturn> {
  // getContent REJECTS on a load failure (Apollo's default errorPolicy "none").
  // This content is only a fallback error message, so a failed read must not
  // abort the reset before its mutation even runs.
  let generalMessage: string | undefined;
  let badUsernameMessage: string | undefined;
  try {
    const { data: contentData } = await getContent(["beErrResetpwGeneral", "beErrUsernameBad"]);
    generalMessage = contentData?.content?.beErrResetpwGeneral ?? undefined;
    badUsernameMessage = contentData?.content?.beErrUsernameBad ?? undefined;
  } catch (e) {
    console.error("Failed to load password-reset error content:", e);
  }

  // Generate reset passworld URL
  const frameConfig = new FrameConfig();
  let resetPasswordUrl = frameConfig.resetPasswordUrl;
  if (!resetPasswordUrl) {
    resetPasswordUrl = frameConfig.parentUrl;
    if (!resetPasswordUrl) resetPasswordUrl = window.location.href.replace("#", "");
  }
  resetPasswordUrl += (resetPasswordUrl.includes("?") ? "&" : "?") + "_bedst=1";

  const client = global.window.apolloClient;
  const mutVars: SendPasswordResetMutationVariables = { resetPasswordUrl, username };
  const result = await client.mutate({
    mutation: SendPasswordResetDocument,
    variables: mutVars,
  });
  
  const success = result.data?.sendPasswordReset?.success ?? false;

  let errorMessage: string | undefined;
  if (!success) {
    errorMessage = generalMessage;
    if (result.data?.sendPasswordReset?.errorType === "BAD_USERNAME") {
      errorMessage = badUsernameMessage;
    }
  }

  return { errorMessage, success };
}
